import { useUser, useClerk, useAuth as useClerkAuth } from '@clerk/clerk-react';

export const useAuth = () => {
  const { user, isLoaded: userLoaded } = useUser();
  const { isSignedIn, isLoaded: authLoaded } = useClerkAuth();
  const clerk = useClerk();

  const signOut = () => {
    clerk.signOut();
  };

  // Usa isSignedIn se disponível, senão verifica se user existe
  const isAuthenticated = isSignedIn ?? !!user;
  const isLoaded = userLoaded && authLoaded;

  return {
    user,
    isLoaded,
    isAuthenticated,
    signOut
  };
};

